/***
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-19 16:08:11
 * @FilePath: \gcp-fe\src\config\const\comm.js
 * @Description: 类型配置文件
 */
/**
 * INDEX_BANNER: 首页海报轮播
 * INDEX_NOTICES: 通知公告
 * INDEX_MALL_PURCHASE: 商城直采
 * INDEX_RESOURCE_SHARING: 资源共享
 * PURCHASE_NOTICE_BANNER: 采购公告海报
 * LAWS_AND_REGULATIONS: 政策法规
 */
export const COMM_TYPE_MAPPING = {
  INDEX_BANNER: 100101,
  INDEX_NOTICES: 100102,
  INDEX_MALL_PURCHASE: 100103,
  INDEX_RESOURCE_SHARING: 100104,
  PURCHASE_NOTICE_BANNER: 100201,
  LAWS_AND_REGULATIONS: 100106
};
